namespace('compass.hotel');

compass.hotel.EmptyStaySummaryWidget = compass.defineWidget(function EmptyStaySummaryWidget(options) {
	var me = this;
	var $j = jQuery;
	var d = jQuery.dom.getContext(this);
	var _settings = options;

	this.render = function(widgetElem) {
		if (compass.isRedesignEnabled()) {
			// Redesign empty state - matches the orange helper text design
			var emptyStateContainer = d.div({ className: 'emptyStaySummary redesign' });
			
			var headerSection = d.div({ className: 'emptyHeader' },
				d.h3({ className: 'emptyTitle' }, 'Reservation Summary'),
				d.div({ className: 'emptySubtitle' }, '0 reservations | 0 nights')
			);
			
			var helperSection = d.div({ className: 'emptyHelper clickable' },
				d.div({ className: 'helperIcon' },
					d.i({ className: 'fa-solid fa-arrow-left' })
				),
				d.div({ className: 'helperText' },
					d.div({ className: 'helperMainText' }, 'Start by selecting a room type to view rates and availability.'),
					d.div({ className: 'helperSubText' }, 'Then choose your dates in the booking grid. Fill out your information to complete.')
				)
			);
			
			// Make the helper section clickable to trigger room type selection
			helperSection.activate(function() {
				me.trigger('EmptyStaySummaryWidget.openRoomTypeDropdown');
			});
			
			emptyStateContainer.append(headerSection, helperSection);
			widgetElem.append(emptyStateContainer);
		} else {
			// Legacy mode - minimal or no display
			// Could show a simple placeholder or nothing at all
			var legacyPlaceholder = d.div({ className: 'emptyStaySummary legacy' });
			widgetElem.append(legacyPlaceholder);
		}
	};

}, {
	WUID : 'CRAP',
	widgetName : 'EmptyStaySummaryWidget'
});